import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { Events } from "@graylog/server-api";
import UserNotification from "util/UserNotification";
import { onError } from "util/conditional/onError";
import i18n from "i18n";
const fetchEvent = (eventId) => Events.getById(eventId).then((data) => data.event);
const useEventById = (eventId, { onErrorHandler } = {}) => {
  const { data, refetch, isLoading, isFetched } = useQuery({
    queryKey: ["event-by-id", eventId],
    queryFn: () => onError(fetchEvent(eventId), (errorThrown) => {
      if (onErrorHandler) onErrorHandler(errorThrown);
      UserNotification.error(
        i18n.t("use_event_by_id_notifications.load_failed", { ns: "events", error: errorThrown }),
        i18n.t("use_event_by_id_notifications.load_failed_title", { ns: "events" })
      );
    }),
    placeholderData: keepPreviousData,
    enabled: !!eventId
  });
  return {
    data,
    refetch,
    isLoading,
    isFetched
  };
};
export default useEventById;
